import { useEffect, useState } from "react";
import { Text, Title, Loader, Center, Group, Stack, Badge } from "@mantine/core";
import { IconWand } from "@tabler/icons-react";
import ReactTimeago from "react-timeago-i18n";
import { useStore } from "../store";
import SelectCard from "../_Common/SelectedCard";
import { getPanelSessions } from "./panelApi";

export default function PanelSessionList() {
  const [sessions, setSessions] = useState([]);
  const [loading, setLoading] = useState(true);

  const selected = useStore((state) => state.selectedPanelSession);
  const setSelected = useStore((state) => state.setSelectedPanelSession);
  const timestamp = useStore((state) => state.panelSessionListTimestamp);

  useEffect(() => {
    setLoading(true);
    getPanelSessions()
      .then(setSessions)
      .finally(() => setLoading(false));
  }, [timestamp]);

  if (loading)
    return (
      <Center>
        <Loader />
      </Center>
    );

  return (
    <Stack>
      <SelectCard selected={selected == null} onClick={() => setSelected(null)}>
        <Group justify="space-between">
          <Text fw={500}>New conversation</Text>
          <IconWand />
        </Group>
      </SelectCard>
      {sessions.map((session) => (
        <SelectCard
          key={session.id}
          onClick={() => setSelected(session)}
          selected={session.id === selected?.id}
        >
          <Group justify="space-between">
            <Title order={5}>{session.title}</Title>
            <Text size="xs" c="dimmed">
              <ReactTimeago date={session.created} />
            </Text>
          </Group>
          <Group gap="xs" mt={4}>
            <Badge size="xs" variant="light">
              {session.panel?.panelists?.length ?? 0} seats
            </Badge>
            <Text size="xs" c="dimmed">
              {session.panel?.name}
            </Text>
          </Group>
        </SelectCard>
      ))}
    </Stack>
  );
}
